import React from 'react';
import PropTypes from 'prop-types';

const Title = ({ actionType, title }) => {
  if (actionType === 'single') {
    switch (title) {
    case 'Delete page':
      return (
        <div className="text-center">
          Delete page
        </div>
      );

    default:
      return '';
    }
  }

  return null;
};

Title.propTypes = {
  actionType: PropTypes.string,
  title: PropTypes.string,
};

export default Title;
